import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./FormationInformation.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import DualButton from "../../../components/DualButton";
import { getFormationById } from '../../../services/formation.service';
import { getPromotionById } from '../../../services/promotion.service';

const FormationInformation = ({ className, data, updateData, currentStep }) => {
  const [formationDetails, setFormationDetails] = useState(null);
  const [promotionDetails, setPromotionDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // États pour les champs du formulaire
  const [formData, setFormData] = useState({
    additionalInfo: '',
    trainingStartDate: '',
    trainingEndDate: '',
    trainingDuration: '',
    remoteTrainingDuration: '',
    annualCost: '',
    freeOfCharge: 'Non',
  });

  // Récupérer les détails de la formation et promotion sélectionnées
  useEffect(() => {
    const fetchDetails = async () => {
      if (!data?.formation) {
        setError(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // Récupérer les détails de la formation
        const formation = await getFormationById(data.formation);
        setFormationDetails(formation);

        // Récupérer les détails de la promotion si sélectionnée
        let promotion = null;
        if (data?.promotion) {
          promotion = await getPromotionById(data.promotion);
          setPromotionDetails(promotion);
        } else {
          setPromotionDetails(null);
        }
        
        // Pré-remplir les champs avec les données de la formation et promotion
        if (formation) {
          const updatedFormData = {
            additionalInfo: '',
            trainingStartDate: promotion?.training_start_date ? new Date(promotion.training_start_date).toISOString().split('T')[0] : '',
            trainingEndDate: promotion?.training_end_date ? new Date(promotion.training_end_date).toISOString().split('T')[0] : '',
            trainingDuration: formation.course_duration || '',
            remoteTrainingDuration: formation.number_of_hoursinstudy || '',
            annualCost: formation.cost_diplome || '',
            freeOfCharge: formation.out_of_pocket_expense_of_0 === 'true' || formation.out_of_pocket_expense_of_0 === true ? 'Oui' : 'Non',
          };
          
          setFormData(updatedFormData);
          
          // Synchroniser immédiatement avec folderData
          if (updateData) {
            updateData('formationInfo', updatedFormData);
          }
        }
      } catch (err) {
        console.error('Erreur lors de la récupération des détails:', err);
        // Ne pas bloquer l'affichage en cas d'erreur, juste logger
        setFormationDetails(null);
        setPromotionDetails(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [data?.formation, data?.promotion]);
  
  // Gérer les changements dans les champs
  const handleInputChange = (name, value) => {
    const newFormData = {
      ...formData,
      [name]: value
    };
    
    setFormData(newFormData);
    
    // Mettre à jour les données du dossier avec toutes les données actuelles
    if (updateData) {
      updateData('formationInfo', newFormData);
    }
  };
  
  const handleDualButtonChange = (name, value) => {
    const newFormData = {
      ...formData,
      [name]: value
    };
    
    setFormData(newFormData);
    
    // Mettre à jour les données du dossier avec toutes les données actuelles
    if (updateData) {
      updateData('formationInfo', newFormData);
    }
  };
  if (loading) {
    return (
      <Item
        className={cn(styles.card, className)}
        title="Détail de formation"
        classTitle="title-green"
      >
        <div className={styles.fieldset}>
          <p>Chargement des informations...</p>
        </div>
      </Item>
    );
  }


  return (
    <Item
      className={cn(styles.card, className)}
      title="Détail de formation"
      classTitle="title-green"
    >
      <div className={styles.fieldset}>
        <div className={styles.group}>
          <TextInput
            className={styles.field}
            label="Date de début de la formation"
            name="trainingStartDate"
            type="date"
            value={formData.trainingStartDate}
            setValue={(value) => handleInputChange('trainingStartDate', value)}
          />
          <TextInput
            className={styles.field}
            label="Date de fin de la formation"
            name="trainingEndDate"
            type="date"
            value={formData.trainingEndDate}
            setValue={(value) => handleInputChange('trainingEndDate', value)}
          />
        </div>
        
        <div className={styles.row}>
          <TextInput
            className={styles.field}
            label="Durée de la formation (heures)"
            name="trainingDuration"
            type="number"
            placeholder="Ex: 1200"
            value={formData.trainingDuration}
            setValue={(value) => handleInputChange('trainingDuration', value)}
          />
          <TextInput
            className={styles.field}
            label="Durée de la formation à distance (heures)"
            name="remoteTrainingDuration"
            type="number"
            placeholder="Ex: 300"
            value={formData.remoteTrainingDuration}
            setValue={(value) => handleInputChange('remoteTrainingDuration', value)}
          />
        </div>
        
        <div className={styles.row}>
          <TextInput
            className={styles.field}
            label="Montant de la formation / an (€)"
            name="annualCost"
            type="number"
            step="0.01"
            placeholder="Ex: 8500.00"
            value={formData.annualCost}
            setValue={(value) => handleInputChange('annualCost', value)}
          />
          <div className={styles.field}>
            <DualButton
              label="Reste à charge à 0 €"
              option1="Oui"
              option2="Non"
              value={formData.freeOfCharge}
              onChange={(value) => handleDualButtonChange('freeOfCharge', value)}
              multiSelect={false}
            />
          </div>
        </div>

      </div>
    </Item>
  );
};

export default FormationInformation;
